import { BallTypeEnum } from "../types/ball-type-enum";
import { Ball } from "./ball";
export class GameState {
  
  public firstCollidedBall: Ball;
  
  public setupCueBall: boolean;
  public ballBallCollision: boolean;
  public ballRailCollision: boolean;
  public ballRailCollisionCount: number;

  public pocketedBalls: Ball[]; // balls pocketed during a player turn
  public ballsInPocket: Ball[]; // balls in pocket during the game

  constructor() {
    this.firstCollidedBall = {} as Ball;
  
    this.setupCueBall = false;
    this.ballBallCollision = false;
    this.ballRailCollision = false;
    this.ballRailCollisionCount = 0;

    this.pocketedBalls = []; // balls pocketed during a player turn
    this.ballsInPocket = []; // balls in pocket during the game 
  }

  /**
   * This removes the cue ball from the pocket for all games.
   */
  public removeCueBallFromPocket(bt: BallTypeEnum): void {
    if (this.ballsInPocket.map((b) => b.type).includes(BallTypeEnum.Cue)) {
      this.ballsInPocket.splice(this.ballsInPocket.findIndex((b) => b.type === bt), 1);
    }
  }

  /**
   * This removes the 9 ball from the pocket for the 9-ball pool game.
   */
  public removeStripeBallFromPocket(bt: BallTypeEnum): void {
    if (this.ballsInPocket.map((b) => b.type).includes(BallTypeEnum.Stripe)) {
      this.ballsInPocket.splice(this.ballsInPocket.findIndex((b) => b.type === bt), 1);
    }
  }

  /**
   * This removes the coloured balls from the pocket for the snooker game. 
   */
  public removeBallFromPocketByPoints(pts: number): void {
    if (this.ballsInPocket.map((b) => b.ballPoints).includes(pts)) {
      this.ballsInPocket.splice(this.ballsInPocket.findIndex((b) => b.ballPoints === pts), 1);
    }
  }
}
